import React, { Fragment, useState, useContext } from 'react';
import { withTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { AppBar, Menu, MenuItem, Toolbar, Typography, IconButton, Grid } from '@material-ui/core'
import MenuIcon from '@material-ui/icons/Menu'
import AccountBoxIcon from '@material-ui/icons/AccountBox'
import { ReactSVG } from 'react-svg'
import SideMenu from './SideMenu'
import { PageContext } from '../Context/PageProvider'
import PasswordModal from '../Components/Modals/PasswordModal'




function Header({ t }) {

    const context = useContext(PageContext)
    const user = context.user
    const classes = useStyles()
    const [drawerMenuOpen, setDrawerMenuOpen] = useState(false)
    const [profileMenuOpen, setProfileMenuOpen] = useState(null)
    const [passwordModalOpen, setPasswordModalOpen] = useState(false)

    const handleProfileClick = (event) => {
        setProfileMenuOpen(event.currentTarget);
    };

    const handleClose = () => {
        setProfileMenuOpen(null);
    };

    const handlePasswordModal = () => {
        setProfileMenuOpen(null)
        setPasswordModalOpen(true)
    }

    const handleLogout = async () => {
        try {
            await context.api.userService.logout()
        } catch (error) {
            console.log('Logout Error,', error)
        }
    }

    return (
        <Fragment>
            <AppBar position="sticky">
                <Toolbar>
                    <IconButton edge="start" className={classes.menuButton} color="inherit" aria-label="menu" onClick={() => setDrawerMenuOpen(true)} ƒ>
                        <MenuIcon />
                    </IconButton>
                    <Grid className={classes.logo}>
                        <ReactSVG src="/assets/logos/logo_big_inveterted.svg" beforeInjection={svg => { svg.setAttribute('width', '38px'); svg.setAttribute('height', 'auto') }} />
                    </Grid>
                    <Typography variant="h6" className={classes.title}>

                    </Typography>
                    <IconButton aria-label="account-button" onClick={handleProfileClick} color="inherit" size="medium">
                        <AccountBoxIcon color="#fff" />
                    </IconButton>
                    <Menu
                        anchorEl={profileMenuOpen}
                        keepMounted
                        open={Boolean(profileMenuOpen)}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handlePasswordModal}>{t('change_password')}</MenuItem>
                        <MenuItem onClick={handleLogout}>{t('logout')}</MenuItem>
                    </Menu>

                </Toolbar>
            </AppBar>
            <SideMenu open={drawerMenuOpen} onClose={() => setDrawerMenuOpen(false)} />
            {
                <PasswordModal
                    open={passwordModalOpen}
                    userId={user && user._id}
                    onClose={() => {
                        setPasswordModalOpen(false)
                    }}
                />
            }
        </Fragment>


    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1
    },
}))

export default withTranslation()(withRouter(Header))